import React from 'react';
import { Helmet } from 'react-helmet-async';
import { TokenSessionProvider } from './TokenSessionProvider';
import LayoutWebpartContainer from './LayoutWebpartContainer';

export default function LayoutEmbed(props) {
  const { title = "", children } = props;
  return (
    <TokenSessionProvider>
      <Helmet>
        <title>{title}</title>
        <script src="/js/iframeResizer.contentWindow.min.js" />
        <script>{`
          window.iFrameResizer = {
            heightCalculationMethod: 'taggedElement'
          };
        `}</script>
        <style>{`
          body { background:transparent !important }    
          `}
        </style>      </Helmet>
      <LayoutWebpartContainer {...props} />
      <div
        data-iframe-height
        style={{ height: '1px', width: '100%', backgroundColor: 'transparent' }}
      />
    </TokenSessionProvider>
  );
}
